const BASKET_CLIENT_ID = "web_pdp_scaffold_ui";

export type ApiResponse = {
  success: boolean;
  commerceItems: Array<object>;
};

export class ApiResponseFactory {
  static failureResponse(): ApiResponse {
    return {
      success: false,
      commerceItems: [],
    };
  }
}

const APPLICATION_JSON = "application/json";

async function updateServices(
  baseUrl: string,
  data: {
    quantity: number;
    parentItemId: string;
    serviceId: string;
  },
): Promise<ApiResponse> {
  const response = await fetch(baseUrl + "/items/service", {
    method: "POST",
    credentials: "include",
    body: JSON.stringify({ ...data, bundleComponentVariantId: null }),
    headers: {
      "x-api-client-id": BASKET_CLIENT_ID,
      "Content-Type": APPLICATION_JSON,
    },
  });
  const { status } = response;

  if (status >= 200 && status <= 299) {
    const commerceItems = (await response
      .json()
      .then((r) => r.basket.commerceItems)) as Array<object>;
    return {
      success: true,
      commerceItems,
    };
  } else {
    return ApiResponseFactory.failureResponse();
  }
}

export const addServiceToBasket = async (
  baseUrl: string,
  parentItemId: string,
  serviceId: string,
  quantity = 1,
) => {
  try {
    const data = {
      parentItemId: parentItemId,
      serviceId: serviceId,
      quantity: quantity,
    };
    return await updateServices(baseUrl, data);
  } catch (e) {
    return ApiResponseFactory.failureResponse();
  }
};

export const removeServiceFromBasket = async (
  baseUrl: string,
  serviceItemId: string,
) => {
  try {
    const response = await fetch(baseUrl + `/items/${serviceItemId}`, {
      method: "DELETE",
      credentials: "include",
      headers: {
        "x-api-client-id": BASKET_CLIENT_ID,
      },
    });
    const { status } = response;

    if (status >= 200 && status <= 299) {
      const commerceItems = (await response
        .json()
        .then((r) => r.basket.commerceItems)) as Array<object>;
      return {
        success: true,
        commerceItems,
      };
    } else {
      return ApiResponseFactory.failureResponse();
    }
  } catch (e) {
    return ApiResponseFactory.failureResponse();
  }
};

export const changeItemQuantity = async (
  baseUrl: string,
  serviceItemId: string,
  quantity: number,
) => {
  try {
    const payload = {
      items: [
        {
          basketItemId: serviceItemId,
          quantity: quantity,
        },
      ],
    };
    const response = await fetch(baseUrl + `/items`, {
      method: "PUT",
      credentials: "include",
      headers: {
        "x-api-client-id": BASKET_CLIENT_ID,
        "Content-Type": APPLICATION_JSON,
      },
      body: JSON.stringify(payload),
    });
    const { status } = response;

    if (status >= 200 && status <= 299) {
      const commerceItems = (await response
        .json()
        .then((r) => r.basket.commerceItems)) as Array<object>;
      return {
        success: true,
        commerceItems,
      };
    } else {
      return ApiResponseFactory.failureResponse();
    }
  } catch (e) {
    return ApiResponseFactory.failureResponse();
  }
};
